module.exports = __webpack_public_path__ + "img/trophy5.png";